import { userEmailHydrator } from '../../fieldOptions/hydrators'

export default [
  { name: 'User', prop: 'member_id', type: 'autocomplete', references: 'admin/users', dataHydrator: userEmailHydrator, referenceProp: 'fullname', displayProp: 'displayVal' },
  { name: 'Membership Plan', prop: 'membership_plan_id', type: 'autocomplete', references: 'admin/membership_plans', referenceProp: 'name' },
  { name: 'Expires', prop: 'expires_at', type: 'date' },
  { name: 'Last Renewal Date', prop: 'renewed_at', type: 'date' },
  { name: 'Create order', prop: 'create_order', type: 'checkbox' }
]
